import React from "react";
import icon from "../../assets/icon.png";

// Shared by the /account sign-in wall and the in-place sign-in dialog so both
// entry points look like the same product.
export function AuthHeader() {
  return (
    <div className="DogZonesAuthHeader">
      <img src={icon} alt="Dog Zones logo" width={56} height={56}/>
      <span>Dog Zones</span>
    </div>
  )
}
